import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useAuthForm } from "@/contexts/AuthFormProvider";

const FinalCTA: React.FC = () => {
  const { showRegisterForm } = useAuthForm();

  return (
    <motion.div 
      className="flex items-center justify-center relative py-16 md:py-20 overflow-hidden"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: false, margin: "-15%" }}
    >
      <motion.div 
        className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-purple-500/5 to-cyan-500/5"
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2, ease: "easeOut" }}
        viewport={{ once: false }}
      />

      <div className="relative z-10 text-center space-y-12 max-w-4xl mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false }}
        >
          <h2 className="text-6xl lg:text-7xl font-black text-white leading-tight mb-6">
            Ready to Transform Your
            <br />
            <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">
              Backend Development?
            </span>
          </h2>
          <p className="text-2xl text-gray-300 leading-relaxed">
            Join thousands of developers generating production-ready microservices in minutes with the first AI that truly understands complex system architecture.
          </p>
        </motion.div>

        <motion.div
          className="flex items-center justify-center"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: false }}
        >
          <motion.button
            onClick={() => {
              window.lintrk('track', { conversion_id: 23344122 });
              showRegisterForm();
            }}
            className="group relative px-16 py-8 rounded-3xl bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 text-white font-black text-2xl shadow-2xl overflow-hidden"
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 0 60px rgba(59, 130, 246, 0.6)"
            }}
            whileTap={{ scale: 0.98 }}
          >
            
            <div className="relative flex items-center space-x-4">
              <span>Start Building Now</span>
              <ArrowRight className="w-8 h-8" />
            </div>

          </motion.button>
        </motion.div>

        <motion.div
          className="flex flex-wrap items-center justify-center gap-8 pt-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          viewport={{ once: false }}
        >
          {[
            { label: "Start Free", color: "bg-green-400" },
            { label: "No credit card required", color: "bg-blue-400" },
            { label: "Cancel anytime", color: "bg-purple-400" },
            { label: "24/7 support", color: "bg-cyan-400" }
          ].map((item, i) => (
            <div key={i} className="flex items-center space-x-3 text-gray-400">
              <div className={`w-3 h-3 ${item.color} rounded-full`}></div>
              <span className="text-lg">{item.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default FinalCTA;